export default __webpack_public_path__ + "static/media/Patronato-hilando.0a16caa1.jpg";